import React from 'react';

import { Grid, Typography, styled } from '@creditas-ui/react';
import { useHistory } from 'react-router-dom';
import { useEjnSelected } from '../../../contexts/ejn';
import { CenterScreenLoading } from '../../base-components/loading/Loading';
import { detailsData } from './DetailsData';
import EjnActions from './EjnActions';
import { Modal } from './modal';

const StyledGrid = styled(Grid)`
  min-height: 72px;
  padding: 0 32px 0 32px;
  gap: 20px;
  border-bottom: 1px solid rgba(237, 240, 239, 1);
  align-items: center;
`;

const buildLine = (key: string, value: JSX.Element) => {
  return (
    <StyledGrid gridTemplateColumns="2fr 3fr">
      <Typography variant={'bodyMdRegular'} color={'neutral.80'}>
        {key}
      </Typography>
      {value}
    </StyledGrid>
  );
};

export const EjnModal: React.FC = () => {
  const history = useHistory();

  const { ejnId, ejn, loading } = useEjnSelected();

  return (
    <Modal
      canShow={!!ejnId}
      hide={() => history.push('/notificacoes-extrajudiciais')}
      title={`# ${ejn?.notification.ccn || ''}`}
    >
      {loading ? (
        <CenterScreenLoading />
      ) : (
        <>
          {ejn &&
            detailsData(ejn).map((detail, idx) => {
              const shouldShow = detail.show();
              return shouldShow ? (
                <React.Fragment key={`${detail.key}-${idx}`}>
                  {buildLine(detail.key, detail.renderValue())}
                </React.Fragment>
              ) : null;
            })}
          <EjnActions />
        </>
      )}
    </Modal>
  );
};
